// Domain + form types for the Calculations tab.

export interface Calculation {
  id: string;
  name: string;
  slug: string;
  expression: string;
}

export interface CalculationFormValues {
  name: string;
  expression: string;
}

export const emptyCalculationForm: CalculationFormValues = {
  name: "",
  expression: "",
};

export interface Operand {
  slug: string;
  name: string;
}

export interface OperandGroups {
  questions: Operand[];
  lookups: Operand[];
  calculations: Operand[];
}

export const OPERATORS: { label: string; insert: string }[] = [
  { label: "+", insert: "+" },
  { label: "−", insert: "-" },
  { label: "×", insert: "*" },
  { label: "÷", insert: "/" },
  { label: "( )", insert: "(" },
  { label: ")", insert: ")" },
  { label: "? :", insert: "? :" },
  { label: ">", insert: ">" },
  { label: ">=", insert: ">=" },
  { label: "==", insert: "==" },
  { label: "!=", insert: "!=" },
  { label: "<=", insert: "<=" },
  { label: "<", insert: "<" },
];

export const unknownOperands = (
  expression: string,
  operandSlugs: string[]
): string[] => {
  const ids = expression.match(/[A-Za-z_][A-Za-z0-9_]*/g) ?? [];
  const known = new Set(operandSlugs);
  return Array.from(new Set(ids)).filter((id) => !known.has(id));
};
